module.exports = {
  'name': 'cot',
  'category': 'Trigonometry',
  'syntax': [
    'cot(x)'
  ],
  'description': 'Compute the cotangent of x in radians. Defined as 1/tan(x)',
  'examples': [
    'cot(2)',
    '1 / tan(2)'
  ],
  'seealso': [
    'sec',
    'csc',
    'tan'
  ]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathsteps/node_modules/mathjs/lib/expression/docs/function/trigonometry/cot.js
// module id = Mknk
// module chunks = 0